import sumBy from 'lodash/sumBy';

export const calculateTotalDelta = (productAggregates, field) =>
  sumBy(productAggregates, `newValues.${field}`) -
  sumBy(productAggregates, `oldValues.${field}`);

export const checkIfDeltasMatch = (totalDelta, otherDeltas, field) =>
  otherDeltas && parseFloat((totalDelta + otherDeltas[field]).toFixed(2)) === 0;

export const hasDeltaChanged = (otherDeltas, field) =>
  otherDeltas && otherDeltas[field] !== 0;
